import { createApp } from '@app/adapters/create-app'
import PastMeetings from '../screens/past/components/past-meetings.vue'
import createMeetingPreparationStore from '@app/application/client_meetings/screens/prepare/stores/main'

onDomLoad(function ($dom) {
  $dom.find("[data-behaviour='client-meetings-past']").each(function () {
    const dataElement = document.getElementById(
      'page-data/client-meetings/past'
    )

    const pageData = JSON.parse(dataElement.textContent)

    const store = createMeetingPreparationStore({
      firmId: Silverfin.currentFirmId,
      companyId: Silverfin.currentCompanyId,
      pastMeetings: true,
    })
    const app = createApp(PastMeetings)

    app.provide('pageData', pageData)
    app.use(store)

    app.mount(this)
  })
})
